// removed by extract-text-webpack-plugin
module.exports = {"background-purple":"#eff0f4","white":"#ffffff","modalPreviewerContainer":"_3jvlXqlrrexYvrqkEZwKsA","previewImage":"_3w-tZHMpI88ej5p-O-D1EF","overlay":"_3wU0C9bh2HPO4ehqc-wIxT","fullScreenModal":"BEfcMpD5wHmBEl6DGB9f3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalPreviewer/ModalPreviewer.css
// module id = 1205
// module chunks = 0